/* 最新消息卡片、分類篩選與分頁。 */
(function () {
  const articles = window.RIEASE_NEWS || [];
  const listRoot = document.getElementById('news-list');
  const paginationRoot = document.getElementById('news-pagination');
  const filters = [...document.querySelectorAll('[data-news-filter]')];
  if (!listRoot || !paginationRoot || !articles.length) return;

  const pageSize = 4;
  let category = 'all';
  let page = Math.max(1, Number(new URLSearchParams(window.location.search).get('page')) || 1);

  function articleUrl(article) {
    return `news-article.html?id=${encodeURIComponent(article.slug)}`;
  }

  function meta(article) {
    return `<div class="news-meta"><span>${article.displayDate}</span><span>${article.categoryLabel}</span></div>`;
  }

  function featuredCard(article) {
    return `
      <a class="news-featured ${article.accentClass} reveal-on-scroll is-visible" href="${articleUrl(article)}" aria-label="閱讀：${article.title}">
        <div class="news-featured-media">
          <img src="${article.image}" alt="${article.imageAlt}" width="1568" height="1003" fetchpriority="high">
          <span class="news-visual-label">${article.label}</span>
        </div>
        <div class="news-featured-body">
          ${meta(article)}
          <h2 class="news-featured-title">${article.title}</h2>
          <p class="news-featured-desc">${article.description}</p>
          <span class="news-read-more"><span>閱讀完整文章</span><span aria-hidden="true">↗</span></span>
        </div>
      </a>`;
  }

  function standardCard(article, index) {
    return `
      <a class="news-card ${article.accentClass} reveal-on-scroll is-visible" href="${articleUrl(article)}" aria-label="閱讀：${article.title}">
        <div class="news-card-media">
          <img src="${article.image}" alt="${article.imageAlt}" width="1568" height="1003" loading="lazy">
          <span class="news-visual-label">${article.label}</span>
          <span class="news-card-index" aria-hidden="true">${String(index + 1).padStart(2, '0')}</span>
        </div>
        <div class="news-card-body">
          ${meta(article)}
          <h2 class="news-card-title">${article.title}</h2>
          <p class="news-card-desc">${article.description}</p>
          <div class="news-card-footer"><span>${article.readingTime}</span><span class="news-card-arrow" aria-hidden="true">↗</span></div>
        </div>
      </a>`;
  }

  function renderPagination(totalPages) {
    if (totalPages <= 1) {
      paginationRoot.innerHTML = '';
      paginationRoot.hidden = true;
      return;
    }

    paginationRoot.hidden = false;
    const pageButtons = Array.from({ length: totalPages }, (_, index) => {
      const number = index + 1;
      return `<button class="news-page-number${number === page ? ' is-active' : ''}" type="button" data-page="${number}"${number === page ? ' aria-current="page"' : ''}>${String(number).padStart(2, '0')}</button>`;
    }).join('');

    paginationRoot.innerHTML = `
      <button class="news-page-step" type="button" data-page="${page - 1}" ${page === 1 ? 'disabled' : ''} aria-label="上一頁">← <span>PREV</span></button>
      <div class="news-page-numbers">${pageButtons}</div>
      <button class="news-page-step" type="button" data-page="${page + 1}" ${page === totalPages ? 'disabled' : ''} aria-label="下一頁"><span>NEXT</span> →</button>`;
  }

  function render(options = {}) {
    const filtered = category === 'all' ? articles : articles.filter((article) => article.category === category);
    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    page = Math.min(page, totalPages);
    const offset = (page - 1) * pageSize;
    const pageArticles = filtered.slice(offset, offset + pageSize);

    if (!pageArticles.length) {
      listRoot.innerHTML = '<p class="news-empty">目前沒有這個分類的文章。</p>';
    } else {
      const [lead, ...rest] = pageArticles;
      listRoot.innerHTML = `${featuredCard(lead)}${rest.length ? `<div class="news-grid">${rest.map((article, index) => standardCard(article, offset + index + 1)).join('')}</div>` : ''}`;
    }

    renderPagination(totalPages);

    const params = new URLSearchParams();
    if (page > 1) params.set('page', page);
    const query = params.toString();
    history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);

    if (options.scroll) {
      document.querySelector('.news-toolbar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      category = button.dataset.newsFilter;
      page = 1;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      render();
    });
  });

  paginationRoot.addEventListener('click', (event) => {
    const button = event.target.closest('[data-page]');
    if (!button || button.disabled) return;
    page = Number(button.dataset.page);
    render({ scroll: true });
  });

  render();
})();